import {
  ListViewComponent,
  listRow,
  getExtraBurgerMenuOptions,
  MenuOption,
} from '@standard-angular-utilities/shared-components';
import { MatDialog } from '@angular/material/dialog';
import { Component, inject, ViewChild } from '@angular/core';
import { Customer } from 'TimelogDataTypes';

import { CustomerService } from 'TimelogServices/customer-service';
import { MatButtonModule } from '@angular/material/button';
import { CustomerDialogComponent } from '../../Dialogs/customer-dialog/customer-dialog.component';
import { LogDTO, LogType, User } from 'BaseDataTypes';
import { LogService } from 'BaseServices/log-service';
import { UserService } from 'BaseServices/user-service';
import { LogHelperService } from 'BaseServices/log-helper.service';

@Component({
  selector: 'app-customer-view',
  imports: [MatButtonModule, ListViewComponent],
  templateUrl: './customer-view.component.html',
  styleUrls: [
    '../../../../../../src/app/general-styles/pages.css',
    './customer-view.component.css',
  ],
})
export class CustomerViewComponent {
  @ViewChild('listView') listView!: ListViewComponent<Customer>;
  @ViewChild('logListView') logListView!: ListViewComponent<LogDTO>;
  onChangeFunction: () => void = () => {};
  logHeaderList: string[];
  customerHeaderList: string[] = ['Kunder'];
  headerList: string[] = this.customerHeaderList;
  customers: Customer[] = [];
  isHistory: boolean = false;
  currentUser = this.userService.currentUser;

  extraBurgerMenuOptions: MenuOption[] = [];

  readonly dialog = inject(MatDialog);

  constructor(
    private customerService: CustomerService,
    private logService: LogService,
    private userService: UserService,
    private logHelper: LogHelperService
  ) {
    this.logHeaderList = this.logService.getLogHeaders('Kunde');
  }

  ngOnInit() {
    const isAdmin =
      this.userService.getSelectedRole ===
      this.userService.getUserRoleTypes.Admin;
    const customLabel = 'Skift til kunder';

    this.extraBurgerMenuOptions = getExtraBurgerMenuOptions(
      isAdmin,
      this.isHistory,
      customLabel,
      this.switchDataInList.bind(this),
      () => this.extraBurgerMenuOptions[0][0],
      (newLabel: string) => {
        this.extraBurgerMenuOptions[0][0] = newLabel;
      }
    );

    this.updateListCustomer();
  }

  /**
   * Opens a dialog with customer details.
   * If customer is null, opens with default data for creating a new.
   * @param customer
   */
  customerClicked(customer?: Customer) {
    if (customer == null) {
      customer = { id: 0, name: '' };
    }

    let dialogref = this.dialog.open(CustomerDialogComponent, {
      data: { data: [customer] },
    });
    dialogref.afterClosed().subscribe((result) => {
      if (result == true) {
        this.updateListCustomer(); // update customer list
      }
    });
  }

  /**
   * Function which switches the list between courses and the course event log.
   */
  switchDataInList() {
    if (this.isHistory) {
      this.updateListCustomer();
      this.isHistory = false;
    } else {
      this.updateListWithLogData();
      this.isHistory = true;
    }
  }

  /**
   * Function to update list with eventlog data
   */
  updateListWithLogData() {
    this.logHelper.updateLogList(
      LogType.Department,
      this.getCustomerNameFromId.bind(this),
      (data) => (this.logListView.listData().listData = data),
      () => this.logListView.update()
    );
  }

  /**
   * Retrieves the updated list of customers from the service
   */
  updateListCustomer() {
    this.customerService.getCustomers().subscribe((result) => {
      let tempList: listRow<Customer>[] = [];
      result.forEach((customer) => {
        tempList.push({
          object: customer,
          id: customer.id,
          data: [customer.name],
        });
      });
      this.customers = result;
      this.listView.listData().listData = tempList;
      this.listView.update();
    });
  }

  getCustomerNameFromId(id: number): string {
    return this.customers.find((c) => c.id === id)?.name || id.toString();
  }
}
